import { checkHashStore } from '../../../store/checkHashStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { autoBetStore } from '../../../store/autoBetStore';
import { wheelBetsStore } from '../wheelStore/betStore';
import { wheelGameConnection } from '../wheelConnection';
import { DEFAULT_AUTO_BET_COUNT } from '../../../core/constants/autoBetContants';
import {
  RISK_TYPES_FOR_CLASS,
  SECTOR_COLORS_TYPES,
  SECTORS_COLORS_INDEXES,
  SECTORS_TYPES_FOR_CLASS,
  WHEEL_ANIMATION_SECONDS,
  WheelSoundsName,
} from '../wheelCore/constants';
import { ValidationType } from '../../../core/constants/validationType';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { notificationStore } from '../../../store/notificationStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

let resetTimeOutId;
let animationTimeOut;

class WheelGameService {
  onGetInitialStateResult({ lastSpinInfo, additionalInfo }) {
    this.resetGameData();
    wheelBetsStore.resetBetStore();
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo({
        key: lastSpinInfo.key,
        salt: lastSpinInfo.salt,
        hash: lastSpinInfo.hash,
      });
      checkHashStore.setLastRoundResult({
        id: lastSpinInfo.id,
        odd: lastSpinInfo.odd,
        riskType: lastSpinInfo.riskType,
        sectorCountType: lastSpinInfo.sectorCountType,
      });
    }
    wheelBetsStore.setOddsDic(additionalInfo.oddsDic);
  }

  doSpin() {
    if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (!wheelBetsStore.isBetsClosed) {
      soundService.play(WheelSoundsName.bet);
      const model = {
        spinData: {
          amount: userInfoStore.betAmount,
          riskType: wheelBetsStore.riskType,
          spectorCount: wheelBetsStore.sector,
        },
        isAutoplay: autoBetStore.isAutoBetOn,
      };
      mainGameConnection.doSpin(model);

      wheelBetsStore.setIsBetsClosed(true);
    }
  }

  handleDoSpinResult({
    responseCode,
    odd,
    salt,
    key,
    hash,
    newHash,
    result,
    balance,
    id,
    winAmount,
  }) {
    if (responseCode === ValidationType.Success) {
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      const { riskType, sectorCountType, sectorColorType } = result;
      wheelBetsStore.setRoundColorOdd(null);
      wheelBetsStore.setRoundColorType(null);
      wheelBetsStore.setWinAmount(0);
      const colorIndexes =
        SECTORS_COLORS_INDEXES[
          RISK_TYPES_FOR_CLASS[riskType] + SECTORS_TYPES_FOR_CLASS[sectorCountType]
        ].indexes[SECTOR_COLORS_TYPES[sectorColorType]];
      const nextIndex = colorIndexes[Math.floor(Math.random() * colorIndexes.length)];
      if (!userSettingsStore.isTurboOn) {
        soundService.play(WheelSoundsName.spinning);
      }
      wheelBetsStore.startWheel(nextIndex, SECTORS_TYPES_FOR_CLASS[sectorCountType]);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }

      animationTimeOut = setTimeout(() => {
        userInfoStore.getBalance();
        wheelBetsStore.setRoundColorOdd(odd);
        wheelBetsStore.setRoundColorType(sectorColorType);
        wheelBetsStore.endWheel(nextIndex, SECTORS_TYPES_FOR_CLASS[sectorCountType]);
        if (winAmount) {
          soundService.play(WheelSoundsName.win);
        } else {
          soundService.play(WheelSoundsName.lose);
        }
        wheelBetsStore.setWinAmount(winAmount);
        wheelBetsStore.setWinOddAndAmount({ winAmount, winOdd: odd });
        setTimeout(() => {
          wheelBetsStore.setWinOddAndAmount({
            winAmount: null,
            winOdd: null,
          });
        }, 2000);
        wheelBetsStore.updateResultSaltAndKey({
          salt,
          key,
          hash,
          newHash,
          odd,
          id,
          riskType,
          sectorCountType,
        });
        wheelBetsStore.updateLastResults({ odd, isWin: !!winAmount });
        betHistoryStore.getLastBet();
        userInfoStore.getBalance();
        wheelBetsStore.setIsBetsClosed(false);
        setTimeout(() => {
          if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
            this.doSpin();
          } else {
            this.resetAutoBetState();
          }
        }, 0);
      }, (userSettingsStore.isTurboOn ? WHEEL_ANIMATION_SECONDS.turbo : WHEEL_ANIMATION_SECONDS.default) * 1000);
    } else {
      wheelBetsStore.setIsBetsClosed(false);
      notificationStore.setNotification(responseCode);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  handleChangeWheelType() {
    const model = {
      riskType: wheelBetsStore.riskType,
      spectorCount: wheelBetsStore.sector,
    };
    wheelGameConnection.changeWheelType(model);
  }

  handleChangeWheelTypeResult({ hash }) {
    checkHashStore.setNextRoundHash(hash);
  }

  clearAutoBetTimeOut() {
    clearTimeout(resetTimeOutId);
    clearTimeout(animationTimeOut);
  }

  resetAutoBetState() {
    autoBetStore.setIsAutoBetStart(false);
    autoBetStore.setIsAutoBetOn(false);
    autoBetStore.setAutoBetCount(DEFAULT_AUTO_BET_COUNT);
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 1500);
    }
  }

  resetGameData() {
    resetTimeOutId = setTimeout(() => {
      wheelBetsStore.resetBetStore();
      if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
        this.doSpin();
      } else {
        this.resetAutoBetState();
      }
    }, 1000);
  }
}

export const wheelGameService = new WheelGameService();
